import { render, staticRenderFns } from "./LixeiraCaptacao.vue?vue&type=template&id=387b0170&"
import script from "./LixeiraCaptacao.vue?vue&type=script&lang=js&"
export * from "./LixeiraCaptacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports